import script from "./ScreenRequestWeek.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenRequestWeek.vue?vue&type=script&setup=true&lang=js"

import "./ScreenRequestWeek.vue?vue&type=style&index=0&id=76c89288&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c89288"]])

export default __exports__